/**
 * @Description:
 * @Author: 菩萨蛮
 * @Date: 2021/3/30 3:49 下午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */
import ClauseDialog from './ClauseDialog';
import DeliveryTimeDialog from './DeliveryTimeDialog';
import FeeDialog from './FeeDialog';
import SaleOrderSelectDialog from './SaleOrderSelectDialog';
import SaleOrderRadioTableDialog from './SaleOrderRadioTableDialog';

export default {
  install(Vue) {
    Vue.component('ClauseDialog', ClauseDialog);
    Vue.component('DeliveryTimeDialog', DeliveryTimeDialog);
    Vue.component('FeeDialog', FeeDialog);
    Vue.component('SaleOrderSelectDialog', SaleOrderSelectDialog);
    Vue.component('SaleOrderRadioTableDialog', SaleOrderRadioTableDialog);
  }
};
